import { Play } from 'lucide-react'
import styles from './CinemaBackground.module.scss'

/**
 * Decorative backdrop for the Viral Shorts form. Six blurred "shorts
 * poster" tiles in different gradients, scattered and rotated, masked by
 * a radial gradient so they fade out at the edges. Pure ambiance — pointer
 * events disabled so it never steals clicks from the form.
 */
export function CinemaBackground() {
  return (
    <div aria-hidden className={styles.bg}>
      {TILES.map((t) => (
        <div
          key={t.id}
          className={styles.tile}
          style={{
            top: t.top,
            bottom: t.bottom,
            left: t.left,
            right: t.right,
            width: `${t.w.toString()}px`,
            height: `${t.h.toString()}px`,
            transform: `rotate(${t.rot.toString()}deg)`,
            background: t.gradient,
          }}
        >
          <div className={styles.play}>
            <Play />
          </div>
          <div className={styles.label}>{t.label}</div>
        </div>
      ))}
    </div>
  )
}

interface Tile {
  id: string
  w: number
  h: number
  rot: number
  gradient: string
  label: string
  top?: string
  bottom?: string
  left?: string
  right?: string
}

const TILES: readonly Tile[] = [
  { id: 'a', top: '4%', left: '2%', w: 220, h: 390, rot: -4, gradient: 'linear-gradient(160deg, #2D1B69, #0B0F3D)', label: 'Por que o espaço faz seu cérebro derreter?' },
  { id: 'b', top: '8%', right: '5%', w: 190, h: 340, rot: 3, gradient: 'linear-gradient(160deg, #7C1D6F, #2D0A40)', label: 'A física quântica que Einstein odiava' },
  { id: 'c', bottom: '6%', left: '10%', w: 200, h: 360, rot: 5, gradient: 'linear-gradient(160deg, #0B3D91, #041240)', label: 'Buracos negros não são buracos' },
  { id: 'd', bottom: '4%', right: '12%', w: 180, h: 320, rot: -6, gradient: 'linear-gradient(160deg, #B83D1F, #3D0A04)', label: 'A maior mentira do Sol' },
  { id: 'e', top: '30%', left: '30%', w: 160, h: 290, rot: -2, gradient: 'linear-gradient(160deg, #064E3B, #021816)', label: 'O que tem dentro de um átomo' },
  { id: 'f', top: '25%', right: '30%', w: 170, h: 310, rot: 4, gradient: 'linear-gradient(160deg, #4C1D95, #1E0845)', label: 'Por que o tempo anda pra trás' },
]
